<template>
    <v-row class="ma-0 pa-0" align="center" justify="center">
        <v-col cols="12" class="chart_style">
            <v-chart :id="chart_id" class="chart" :option="option" autoresize></v-chart>
        </v-col>
        <v-col cols="auto" class="py-0">
            <span class="chart_title">{{ statistic_title_name }}</span>
        </v-col>
    </v-row>
</template>

<script>
    import VChart, { THEME_KEY } from 'vue-echarts';
    import "echarts";
    import { use } from 'echarts/core';
    import { CanvasRenderer } from 'echarts/renderers';
    import {
        TitleComponent,
        TooltipComponent,
        LegendComponent,
    } from 'echarts/components';

    // import {COLOR_PALETTE} from "./chart_constants.js"

    use([
        CanvasRenderer,
        TitleComponent,
        TooltipComponent,
        LegendComponent,
    ]);
    export default {
        name: 'MultiGaugeChart',
        props: [
            'statistic_title_name',
            'value',
            'link',
            'chart_id'
        ],
        components: {
            VChart
            // GChart
        },
        provide: {
            [THEME_KEY]: 'light',
        },
        setup(props) {
            let dataset = props.value;

            let data = [];
            let data_titles = [];

            if(dataset != null){
                for(let idx = 0; idx < dataset.length; idx ++){
                    if(idx > 0){
                        data.push({
                            name: dataset[idx][0],
                            value: dataset[idx][1]
                        })
                        data_titles.push(dataset[idx][0]);
                    }
                }
            }
            const gaugeData = [
                {
                    value: props.value[0][1],
                    name: 'Open',
                    title: {
                        offsetCenter: ['0%', '-40%']
                    },
                    detail: {
                        valueAnimation: true,
                        offsetCenter: ['0%', '-20%'],
                        color: '#020446'
                    }
                },
                {
                    value: props.value[1][1],
                    name: 'Closed',
                    title: {
                        offsetCenter: ['0%', '10%']
                    },
                    detail: {
                        valueAnimation: true,
                        offsetCenter: ['0%', '30%'],
                        color: '#020446'
                    }
                }
                ];
            const option = {
                series: [
                    {
                    color: ['#1230EF','#020446'],
                    type: 'gauge',
                    startAngle: 90,
                    endAngle: -270,
                    radius: '100%',
                    pointer: {
                        show: false
                    },
                    progress: {
                        show: true,
                        overlap: false,
                        roundCap: true,
                        clip: false,
                        itemStyle: {
                            borderWidth: 1,
                            borderColor: '#464646'
                        }
                    },
                    axisLine: {
                        lineStyle: {
                            width: 20
                        }
                    },
                    splitLine: {
                        show: false,
                        distance: 0,
                        length: 10
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false,
                        distance: 1
                    },
                    data: gaugeData,
                    title: {
                        fontSize: 12
                    },
                    detail: {
                        width: 50,
                        height: 8,
                        fontSize: 14,
                        color: 'inherit',
                        borderColor: 'inherit',
                        borderRadius: 20,
                        borderWidth: 1,
                        formatter: '{value}%'
                    }
                    }
                ]
                };
            return {option}
        },
        methods: {
            format_data: function(dataset){
                let data = [];
                let data_titles = [];
                if(dataset != null){
                    for(let idx = 0; idx < dataset.length; idx ++){
                        if(idx > 0){
                            data.push({
                                name: dataset[idx][0],
                                value: dataset[idx][1]
                            })
                            data_titles.push(dataset[idx][0]);
                        }
                    }
                }
                this.option['series'][0]['data'] = data;
                this.option['legend']['data'] = data_titles;
            },
            open_further_details: function(){
                if(this.link){
                    this.$router.replace(this.link);
                }
            }
        }
    }
</script>

<style scoped>
    .chart_title{
        font-family: "Gothic Bold" !important;
        font-size: 10pt !important;
        line-height: 40px;

        display: block;
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .chart_style{
        height: 25vh;
        font-family: "Gothic" !important;
    }
</style>